module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Latest Press Releases","msg0":"Browse press releases","msg1":"Press Releases","msg2":"for {year} Press Releases"},"ar":{"page-title":"آخر الأخبار والبيانات الصحفية","msg0":"تصفح جميع البيانات الصحفية","msg1":"المركز الإعلامي","msg2":"بيانات صحفية لسنة {year}"}}')
  delete Component.options._Ctor
}
